import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";

// Material 3 small top app bar. @material/web doesn't ship one yet (its roadmap
// lists "Top app bar" as unimplemented). This is a faithful small variant: an
// optional leading slot (e.g. a menu/back icon button), a centered-left
// headline, and a trailing slot for actions — on the standard --md-sys-* tokens.
@customElement("dpp-top-app-bar")
export class DppTopAppBar extends LitElement {
  static styles = css`
    :host {
      display: block;
    }

    header {
      display: flex;
      align-items: center;
      gap: 4px;
      height: 64px;
      padding: 0 4px 0 12px;
      background: var(--md-sys-color-surface-container);
      color: var(--md-sys-color-on-surface);
    }

    .headline {
      flex: 1;
      min-width: 0;
      font-size: 1.375rem;
      font-weight: 500;
      line-height: 1.75rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .leading,
    .trailing {
      display: inline-flex;
      align-items: center;
      gap: 4px;
    }

    .leading {
      margin-right: 4px;
    }
  `;

  /** The bar title. */
  @property() headline = "";

  render() {
    return html`
      <header>
        <span class="leading"><slot name="leading"></slot></span>
        <h1 class="headline">${this.headline}</h1>
        <span class="trailing"><slot name="trailing"></slot></span>
      </header>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "dpp-top-app-bar": DppTopAppBar;
  }
}
